const presetElements = [
  {
    type: 'transfer',
    element: 'el-transfer'
  }
]

export default presetElements
